import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { PartnerFormData } from '../../../../shared/models/partner-form-data';
import { AdminService } from '../../services/admin';

@Component({
	selector: 'app-partner-form',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatSelectModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent],
	templateUrl: './partner-form.html',
	styleUrl: './partner-form.css'
})
export class PartnerForm {
  	partnerForm: FormGroup;
    isEditMode: boolean = false;
	private _partnerIdToUpdate: string | null = null;

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<PartnerForm, PartnerFormData | undefined>,
        @Inject(MAT_DIALOG_DATA) public data: PartnerFormData | null,
        private adminService: AdminService
    ) {
        this.isEditMode = !!data;
        
		if(this.isEditMode) {
			this._partnerIdToUpdate = data?.uid || null;
		}

		const formConfig: {[key: string]: any} = {
			email         : [data?.email || '', [Validators.required, Validators.email]],
            displayName   : [data?.displayName || ''],
            disabled      : [data?.disabled ?? false],
            paysISR       : [data?.paysISR ?? false],
            billingMode   : [data?.billingMode || 'DAILY', [Validators.required]],
            notificationGroupingMode: [data?.notificationGroupingMode || 'partner_bus', [Validators.required]],
            NIT           : [data?.NIT || ''],
			accountNumber : [data?.accountNumber || '']
		}

		if(!this.isEditMode) {
			formConfig['sendEmail'] = [false];
		}

		this.partnerForm = this.fb.group(formConfig);
    }

    get emailControl() {
        return this.partnerForm.get('email');
    }

    get paysISRControl() {
    	return this.partnerForm.get('paysISR');
  	}

  	get NITControl() {
    	return this.partnerForm.get('NIT');
  	}

	get accountNumberControl() {
		return this.partnerForm.get('accountNumber');
	}

	get sendEmailControl() {
		return this.partnerForm.get('sendEmail');
	}

  get billingModeControl() {
    return this.partnerForm.get('billingMode');
  }

  get notificationGroupingModeControl() {
    return this.partnerForm.get('notificationGroupingMode');
  }

    onSubmit(): void {
        this.partnerForm.markAllAsTouched();

        if(this.partnerForm.valid) {
			const formData = this.partnerForm.value;
			let   resultData: PartnerFormData;

			if(this.isEditMode && this._partnerIdToUpdate) {
				resultData = { ...formData, uid: this._partnerIdToUpdate } as PartnerFormData;
			} else {
				resultData = formData as PartnerFormData
			}

        	this.dialogRef.close(resultData);
        }
    }

    onCancel(): void {
        this.dialogRef.close(undefined);
    }

    async onSendWelcomeEmail(): Promise<void> {
        if(!this.isEditMode || !this._partnerIdToUpdate) {
            return;
        }

        if(!window.confirm('¿Confirmas el envío del correo de bienvenida? Esto restablecerá la contraseña.')) {
            return;
        }

        await this.adminService.sendPartnerWelcomeEmail(this._partnerIdToUpdate);
    }
}
